import { Injectable } from '@angular/core';
import { ApiCallHandler, EoHttpClient, IDataService, IHttpParams, PaginatedSearchResult, STATUS } from 'ngx-eo-web-components';
import { Observable } from 'rxjs';
import { CoreService } from '../../modules/core/core.service';
import { usersMock } from './user.mock.data';
import { IUser, User } from '../../modules/core/models/user.model';
import { environment } from '../../../environments/environment';
import { ISortParams } from '../../modules/shared/models/sort.model';

@Injectable({
  providedIn: 'root',
})
export class UserService implements IDataService<User> {

  constructor(private http: EoHttpClient, private coreService: CoreService) { }
  public searchCh = new ApiCallHandler<PaginatedSearchResult<User> | null>();

  public userListCallHandler = new ApiCallHandler<User[] | null>();
  public userListByRoleCallHandler = new ApiCallHandler<PaginatedSearchResult<User> | null>();
  public userSaveCallHandler = new ApiCallHandler<User | null>();
  public userUpdateCallHandler = new ApiCallHandler<User | null>();
  public exportExcelUsersCallHandler = new ApiCallHandler();


  init() {
    this.userListCallHandler.init([]);
    this.userListByRoleCallHandler.init();
    this.searchCh.init();
    this.userSaveCallHandler.init(null);
    this.userUpdateCallHandler.init(null);
    this.exportExcelUsersCallHandler.init();
  }

  private getAllUsersMock(): Observable<User[]> {
    this.userListCallHandler.status$.next(STATUS.loading);

    const obs$ = new Observable<IUser[]>((sub) => {
      setTimeout(() => {
        sub.next(usersMock);
        this.userListCallHandler.data$.next(usersMock);
        this.userListCallHandler.status$.next(STATUS.success);
      }, 2000);
    });
    return obs$;
  }

  getAllUsers() {
    if (environment.useMock) return this.getAllUsersMock();

    const param: IHttpParams = this.coreService.initCall(
      `/v1/Users/list`,
      this.userListCallHandler
    );

    return this.http.get<User[]>(param);
  }

  searchUsers(
    searchParams: {
      QueryTerm: string;
      Role: string;
      SortParams: ISortParams | null;
    } = { QueryTerm: '', Role: '', SortParams: null },
    pagesize: number,
    page: number
  ): Observable<PaginatedSearchResult<User>> {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Users/search/${pagesize}/${page}`,
      this.searchCh,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<User>>(param);
  }

  searchUsersByCustomersAdmins(
    searchParams: {
      QueryTerm: string;
      Role: string;
      SortParams: ISortParams | null;
    } = { QueryTerm: '', Role: '', SortParams: null },
    pagesize: number,
    page: number
  ): Observable<PaginatedSearchResult<User>> {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Users/searchCustomerUsers/${pagesize}/${page}`,
      this.searchCh,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<User>>(param);
  }

  getAuditorUsers(
    pagesize: number,
    page: number,
    requestType: string,
  ): Observable<PaginatedSearchResult<User>> {
    const searchParams = {
      requestType: requestType,
    };
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Users/searchAuditorUsers/${pagesize}/${page}`,
      this.userListByRoleCallHandler,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<User>>(param);
  }

  saveUser(user: User) {
    let body = {
      userName: user.userName,
      userEmail: user.email,
      firstName: user.name ?? '',
      lastName: user.surname ?? '',
      password: '',
      roleNames: user.roles,
      lockoutEnabled: user.lockoutEnabled,
      customerID: user.customerID,
    };
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Users/save',
      this.userSaveCallHandler,
      body
    );
    return this.http.post(param);
  }

  updateUser(user: User) {
    let body = {
      userId: user.userID,
      userEmail: user.email,
      firstName: user.name,
      lastName: user.surname,
      roleNames: user.roles,
      lockoutEnabled: user.lockoutEnabled,
      customerID: user.customerID,
    };
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Users/update',
      this.userUpdateCallHandler,
      body
    );
    return this.http.post(param);
  }

  exportUsersExcel(
    filter: any
  ) {

    const param: IHttpParams = this.coreService.initCall(
      '/v1/Users/export-excel',
      this.exportExcelUsersCallHandler,
      filter
    );

    return this.http.downloadFile(param);
  }
}
